import { Button, Flex, PopupIcon, Text } from "@fluentui/react-northstar";
import React, { FunctionComponent, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { ClientType, Functions } from "../../../../../../GlobalComponents/Functions";
import { checkLanguageGerman } from "../../../../../../Utilities/Language";
import { getSelectedProductInformation } from "../../../../../../Utilities/Product";
import style from "./CustomTMHeader.module.scss";

interface HeaderProps {
}

const CustomEUMHeader: FunctionComponent<HeaderProps> = () => {
    const [bigScreenSize, setBigScreenSize] = useState<boolean>(true);
    const [isMobile] = useState(Functions.GetClientType(navigator.userAgent)===ClientType.mobile);

    useEffect(() => {
        const handleResize = () => {
        setBigScreenSize(window.innerWidth >= 700);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <header className={style.header}>
        <div id={style.HeaderWrapper}>
            <Flex inline wrap={!bigScreenSize} vAlign="center" hAlign="center" gap="gap.smaller" className={style.flexWrapper}>
            <div id={style.HeaderControlArea}>
                <Text
                    content={<div className={style.headerTitle}><FormattedMessage id={getSelectedProductInformation().getStarted.header.titleId} defaultMessage={getSelectedProductInformation().getStarted.header.altTitle} ></FormattedMessage></div>}
                    id={style.HeaderTitle}
                />
                <Text
                    weight="semilight"
                    content={<div className={style.description}><FormattedMessage id={getSelectedProductInformation().getStarted.header.descriptionId} defaultMessage={getSelectedProductInformation().getStarted.header.altDescription} ></FormattedMessage></div>}
                />
                <Flex gap="gap.smaller" id={style.HeaderButtons}>
                    <Button content={
                    <>
                        <PopupIcon outline size="medium" style={{ "paddingRight": "5px", "paddingBottom": "2px" }} />
                        <FormattedMessage id={getSelectedProductInformation().getStarted.header.primaryButtonTextId} defaultMessage={getSelectedProductInformation().getStarted.header.primaryButtonText} ></FormattedMessage>
                    </>
                    } primary onClick={() => { checkLanguageGerman() ? window.open(getSelectedProductInformation().getStarted.header.german.primaryButtonLink, "_blank") : window.open(getSelectedProductInformation().getStarted.header.english.primaryButtonLink, "_blank") }} />
                    {
                    getSelectedProductInformation().getStarted.header.secondaryButtonTextId && !isMobile &&
                    <Button secondary content={
                        <>
                        <PopupIcon outline size="medium" style={{ "paddingRight": "5px", "paddingBottom": "2px" }} />
                        <FormattedMessage id={getSelectedProductInformation().getStarted.header.secondaryButtonTextId} defaultMessage={getSelectedProductInformation().getStarted.header.secondaryButtonText} ></FormattedMessage>
                        </>
                    } onClick={() => {
                        checkLanguageGerman() ? window.open(getSelectedProductInformation().getStarted.header.german.secondaryButtonLink, "_blank") : window.open(getSelectedProductInformation().getStarted.header.english.secondaryButtonLink, "_blank")
                    }} />}
                </Flex>
            </div>

            {checkLanguageGerman() ? <iframe
                title="embeddedVideoPitch"
                width="550"
                height="360"
                src="https://www.youtube.com/embed/8AXuF9JanhA"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ borderTopRightRadius: '8px', borderBottomRightRadius: '8px'}}
            ></iframe> : <iframe
                title="embeddedVideoPitch"
                width="550"
                height="330"
                src="https://www.youtube.com/embed/d0Mr9IEGKf4?list=PLVE_Lp0amIFqJ4Q4JB0xZgn-AnkKG7R7j"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ borderTopRightRadius: '8px', borderBottomRightRadius: '8px'}}
            ></iframe>}
            </Flex>
        </div>
        </header>
    );
    }

    export default CustomEUMHeader;